import React from "react";
import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  IconButton, 
  Typography, 
  Button,
  Box,
  useTheme,
  Avatar
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import LogoutIcon from '@mui/icons-material/Logout';
import { logOut } from "../common/util"; // Adjust this import path to match your project structure

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: "350px",
    maxWidth: "550px",
    width: "90%",
    backgroundColor: "#041A29",
    color: "#E2E8F0",
    borderRadius: "12px",
    padding: theme.spacing(2),
    border: "1px solid #1E293B",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.25)",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1.5),
    top: theme.spacing(1.5),
    color: "#94A3B8",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
    },
  },
  content: {
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  verificationIcon: {
    backgroundColor: "rgba(56, 189, 248, 0.1)",
    color: "#FFC857",
    width: theme.spacing(8),
    height: theme.spacing(8),
    marginBottom: theme.spacing(2),
    "& svg": {
      fontSize: "2.5rem",
    },
  },
  title: {
    fontWeight: 600,
    color: "#F8FAFC",
    fontSize: "1.5rem",
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: "#94A3B8",
    fontSize: "14px",
    marginBottom: theme.spacing(3),
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
    width: "100%",
  },
  button: {
    borderRadius: "8px",
    padding: theme.spacing(1.75),
    fontWeight: 500,
    textTransform: "none",
    fontSize: "0.95rem",
    transition: "all 0.2s ease",
    width: "100%",
  },
  primaryButton: {
    background: "#BB0A21",
    color: "white",
    "&:hover": {
      background: "rgb(248, 62, 62)",
      boxShadow: "0 4px 6px rgba(2, 132, 199, 0.25)",
    },
  },
}));

const VerificationModal = ({ open, onClose }) => {
  const classes = useStyles();
  const theme = useTheme();

  const handleLogout = () => {
    onClose(); // Close the modal first
    logOut(); // Then trigger the logout process
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      aria-labelledby="verification-dialog-title"
    >
      <DialogTitle disableTypography className={classes.title}>
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Avatar className={classes.verificationIcon}>
          <VerifiedUserIcon />
        </Avatar>
        
        <Typography variant="h5" className={classes.title}>
          Your account is under review
        </Typography>
        
        <Typography variant="body1" className={classes.subtitle}>
          We're reviewing your documents. This usually takes 24-48 hours.
        </Typography>

        <Box className={classes.buttonContainer}>
          <Button 
            variant="contained" 
            className={`${classes.button} ${classes.primaryButton}`}
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
          >
            Log Out
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VerificationModal;